































































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Inquiry, DEFAULT_INQUIRY, InquiryAnswer } from "#/model/inquiry";
import { sanitizeRichText } from "@/utils/sanitize";
import UtilMixin from "@/mixins/utilMixin";
import AnswerContent from "@/components/contact/AnswerContent.vue";
import InquiryFileViewer from "@/components/contact/InquiryFileViewer.vue";
import InquiryAnswerFileViewer from "@/components/contact/InquiryAnswerFileViewer.vue";
import InquiryQuestionnaireForm from "@/components/contact/InquiryQuestionnaireForm.vue";
import { ACCESS_CONFIRMS } from "@/const/contact";

@Component({
  components: {
    AnswerContent,
    InquiryFileViewer,
    InquiryAnswerFileViewer,
    InquiryQuestionnaireForm
  }
})
export default class ContactView extends Mixins(UtilMixin) {
  /** 親問合せ */
  @Prop({ default: DEFAULT_INQUIRY }) parentInquiry!: Inquiry;
  /** 表示対象の問合せ */
  @Prop({ default: DEFAULT_INQUIRY }) inquiry!: Inquiry;

  /** 登録状況確認希望の定数 */
  private ACCESS_CONFIRMS = ACCESS_CONFIRMS;

  private get HtmlContact() {
    if (!this.inquiry.contact) {
      return "";
    }
    return sanitizeRichText(this.inquiry.contact.replace(/\r?\n/g, "<br>"));
  }

  /** CSアンケート回答 */
  @Emit("click:answer")
  private answerQuestionnaire(inquryAnswer: InquiryAnswer) {
    return { inquiry: this.inquiry, inquiry_answer: inquryAnswer };
  }
}
